<template>
  <div>
    <v-container class="full-height" style="padding-top: 80px;">
      <v-row justify="center">
        <v-col lg="6">
          <v-card flat :loading="loading">
            <div class="pa-10 text-center" style="font-size: 24px" :class="textclass">{{message}}</div>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <Footer />
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "Confirmation",
  components: {},
  data() {
    return {
      loading: true,
      message: "...email confirmation in progress",
      textclass: 'text-grey'
    };
  },
  computed: {},
  mounted() {
    this.confirm()
  },
  methods: {
    confirm() {
      axios
        .get(
          "https://tradeinpool.com:3001/api/users/confirmation/" +
            this.$route.params.token
        )
        .then(response => {
          this.loading = false;
          if (response.data.response) {
            this.message = "Success!";
            this.textclass = "profit"
          } else {
            this.message = "User NOT found or already confirmed...";
            this.textclass = "loss"
          }
        })
        .catch(err => {
          this.loading = false;
          this.message = err;
        });
    }
  }
};
</script>

<style scoped>
</style>